import { render } from "./QuestionFourteen.vue?vue&type=template&id=32c3f446"
import script from "./QuestionFourteen.vue?vue&type=script&lang=js"
export * from "./QuestionFourteen.vue?vue&type=script&lang=js"

import "./QuestionFourteen.vue?vue&type=style&index=0&id=32c3f446&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__